import { render, staticRenderFns } from "./ModalFinalizarProposta.vue?vue&type=template&id=08e1e720"
import script from "./ModalFinalizarProposta.vue?vue&type=script&lang=js"
export * from "./ModalFinalizarProposta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports